namespace $.$$ {

	export class $shm_hitalama_map_widget_float_settings_text_md extends $.$shm_hitalama_map_widget_float_settings_text_md {

		link_favicon( next?: boolean ) {
			return this.controlled_widget().link_favicon( next )
		}

	}

}
